export default "__VITE_ASSET__9iKJ6siD__"